module.exports = __webpack_public_path__ + "static/media/arrowleft.57096056.svg";